import { Home } from 'containers/Home'
import { buildPageComponent } from 'containers/PageWrapper'

const HomePage = buildPageComponent(Home, {})

export default HomePage
